export default __webpack_public_path__ + "static/ab-banking-mobile-50b44b0981397185e86e6ae705dc1212.jpg";